import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@narmi/design_system";

const FilterCheckbox = ({ filter, toggleFilter, filters, label }) => (
  <div style={{ padding: "8px" }}>
    <Checkbox
      label={label}
      checked={filters.indexOf(filter) !== -1}
      onChange={() => toggleFilter(filter)}
      testId={`${label}-checkbox`}
    />
  </div>
);

FilterCheckbox.propTypes = {
  filter: PropTypes.func,
  toggleFilter: PropTypes.func,
  filters: PropTypes.array,
  label: PropTypes.string,
};

export default FilterCheckbox;
